import Wt from "./filter-set.js";
export default class Yt {
  constructor(t, s) {
    (this.yl = t), (this.Jl = s), (this.yl = t), (this.Jl = s);
  }
  Bl(t) {
    if (null == this.yl || null == this.Jl) return !1;
    const s = t[0],
      i = t[1];
    return s === this.yl && this.Jl.Bl(i);
  }
  static fromJson(t) {
    return new Yt(
      t ? t.event_name : null,
      t ? Wt.fromJson(t.property_filters) : null,
    );
  }
  tt() {
    return { e: this.yl, pf: this.Jl ? this.Jl.tt() : null };
  }
}
